export const transformCountryBoundsDto = _ref => {
  let {
    radius,
    center,
    top_left,
    bottom_right,
    top_right,
    bottom_left
  } = _ref;
  return {
    radius,
    center,
    topLeft: top_left,
    bottomRight: bottom_right,
    topRight: top_right,
    bottomLeft: bottom_left
  };
};